module.exports = __webpack_public_path__ + "media/images/cart/cart_btn02_ov-50e3f2c12b5a0a6795c0a4edd6acb6c4.gif";